export default {
    data: {
        key: 'gps',
        groups: [
            {
                headerName: 'Identifier',
                field: 'key',
            },
            {
                headerName: 'Name',
                field: 'name',
            },
            {
                headerName: 'Description',
                field: 'description',
            },
            {
                headerName: 'Group',
                field: 'group',
            },
            {
                headerName: 'Type',
                field: 'type',
            },
            {
                headerName: 'Validators',
                field: 'validators',
            },
            {
                headerName: 'Sources',
                field: 'mappers',
            },
            {
                headerName: 'Styles',
                field: 'styles',
            },
        ],
        fields: [
            {
                key: 'gpId',
                name: 'Gp Id',
                description: '',
                group: 'Identification',
                type: 'int',
                validators: [
                    'unique',
                    'required',
                ],
                styles: [],
                mappers: {},
            },
            {
                key: 'name',
                name: 'Name',
                description: '',
                group: 'Identification',
                type: 'string',
                validators: [],
                styles: [],
                mappers: {},
            },
        ],
    },
}
